const LatLng = require('./latlng');
const _ = require('lodash');
let _settingService, _nearestStoresLimit = 5; //the deafult value is 5

function ShopLocatorService(restangular, settingsService) {
    _settingService = settingsService;
    _settingService.getSettingValue('StoreLocator', 'NearestStoresLimit').then(function (setting) {
        _nearestStoresLimit = setting || 5; //the deafult value is 5
    });

    this._storeLocatorApi = restangular.one('StoreLocator');
    this._suburbsApi = this._storeLocatorApi.one('Suburbs');
    this._storesApi = this._storeLocatorApi.one('Stores');
    this.canBeDelivered = null;
}

ShopLocatorService.prototype.getDefaultLocation = function () {
    return this._storeLocatorApi.one('DefaultLanding').get().then(data => {
        this.defaultCoords = new LatLng(data.latitude, data.longitude);
    });
};

ShopLocatorService.prototype.setLocation = function (coords) {
    this.defaultCoords = new LatLng(coords);
};

ShopLocatorService.prototype.listSupermarkets = function (data) {
    if (data.Max) {
        data.Max = _nearestStoresLimit;
    }
    data.CheckStoreClosing = true;
    return this._storesApi.one('bws').get(data).then(function (response) {
        return response ? response.plain() : [];
    });
};

ShopLocatorService.prototype.searchSupermarketByPostcode = function (postcode, max, checkCartAvailability) {
    return this._storesApi.one('bws').get({
        Max: _nearestStoresLimit,
        PostCode: postcode,
        Latitude: this.defaultCoords ? this.defaultCoords.latitude : undefined,
        Longitude: this.defaultCoords ? this.defaultCoords.longitude : undefined,
        CheckCartAvailability: checkCartAvailability
    }).then(function (response) {
        return response ? response.plain() : [];
    });
};

ShopLocatorService.prototype.searchSuburbs = function (searchTerm) {
    return this._suburbsApi.get({
        SearchTerm: searchTerm
    }).then(function (response) {

        //TODO: Remove this when the prop is deleted from response
        response.Suburbs.map((suburb) => {
            delete suburb.FulfilmentStoreId;
        });

        return response && response.Suburbs ? response.Suburbs : [];
    });
};

ShopLocatorService.prototype.checkNearbyStocks = function (dto) {
    return this._storesApi.one('NearbyStock').get(dto).then(function (response) {
        return response && response.StoreStockDetails ? response.StoreStockDetails : [];
    });
};

ShopLocatorService.prototype.searchOtherShopByPostcode = function (postcode) {
    return this._storesApi.one('others').get({
        PostCode: postcode,
        Latitude: this.defaultCoords.latitude,
        Longitude: this.defaultCoords.longitude
    }).then(function (response) {
        return response && response.Stores ? response.Stores : [];
    });
};


const storeCache = {};

ShopLocatorService.prototype.getStore = function (storeNo) {

    const cache = storeCache[storeNo];
    if (!_.isUndefined(cache)) {
        return cache;
    }

    storeCache[storeNo] = this._storeLocatorApi.one('Store').get({ Division: 'bws', StoreNo: storeNo });
    return storeCache[storeNo];
};

ShopLocatorService.prototype.generateUrlParamsForStoreInfos = function (store) {
    if (store) {
        let state, suburb, storeNo, storeUrl;

        if (store.State) {
            state = store.State.trim();
        }

        if (store.AddressState) {
            state = store.AddressState.trim();
        }
        if (store.SuburbName) {
            suburb = store.SuburbName.trim();
        }

        if (store.Suburb) {
            suburb = store.Suburb.trim();
        }

        if (store.AddressSuburb) {
            suburb = store.AddressSuburb.trim();
        }

        if (store.FulfilmentStoreID) {
            storeNo = store.FulfilmentStoreID;
        }

        if (store.StoreNo) {
            storeNo = store.StoreNo;
        }

        if (store.StoreId) {
            storeNo = store.StoreId;
        }

        storeUrl = state + ' ' + suburb + ' ' + storeNo;
        storeUrl = storeUrl.replace(/[^a-zA-Z0-9]/g, ' ').replace(/\s+/g, '-');
        return storeUrl.toLowerCase();
    }
    return '';
};

ShopLocatorService.prototype.getStoreInfoFromUrlParams = function (storeParam) {
    let storeInfo;
    const params = storeParam.split('-');
    const lastIndexOfParams = params.length - 1;

    // check that we have enough parameters
    if (params.length >= 3) {

        //parse store number
        const storeNo = parseInt(params[lastIndexOfParams], 10);

        //only continue if storeNo is a valid number
        if (storeNo) {
            storeInfo = {};
            storeInfo.storeNo = storeNo;
            storeInfo.state = params[0];

            // get the suburb
            const suburbArray = params.slice(1, lastIndexOfParams);
            storeInfo.suburb = suburbArray.join(' ');
        }
    }
    return storeInfo;
};

ShopLocatorService.prototype.urlParametersValid = function (store, parameters) {
    return store.State.toLowerCase() === parameters.state && store.Suburb.toLowerCase() === parameters.suburb && parseInt(store.StoreNo) === parameters.storeNo;
};

ShopLocatorService.prototype.setSelectedStore = function (store) {
    this.selectedStore = store ? store : undefined;
};

ShopLocatorService.prototype.setSelectedStoreState = function (storeState) {
    this.selectedStoreState = storeState ? storeState : undefined;
};

ShopLocatorService.prototype.getStoresByState = function (state, noOfStores) {
    return this._storesApi.one('bws?state=' + state + '&type=allstores&Max=' + noOfStores).get()
        .then(function (response) {
        return response;
    });
};

ShopLocatorService.prototype.getAvailableTrolleyItems = function (storeNo) {
    return this._storeLocatorApi.one(`Store/TrolleyItemsAvailability?StoreNo=${storeNo}`).get()
    .then((response) => {
        return response.plain();
    });
};

ShopLocatorService.prototype.deliveryStores = function (storeNumber, maxNumber, checkCartAvailability) {
    return this._storeLocatorApi.one('DeliveryStores').get({
        StoreNumber: storeNumber,
        MaxNumber: _nearestStoresLimit,
        CheckCartAvailability: checkCartAvailability
    }).then(response => {
        this.canBeDelivered = response.CanBeDelivered;
        return response.plain();
    });
};


module.exports = ShopLocatorService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shoplocator/shop-locator-service.js
 **/